import { SmartMeterGateway } from '../api/dto'
import { SmartMeterGatewayModel } from '../model'

const fromSmartMeterGatewayDtoToModelTransformer = (dto: SmartMeterGateway): SmartMeterGatewayModel => ({
  isEebusDetectionEnabled: dto.isEebusDetectionEnabled,
  isSmartMeterConnected: dto.isHeartbeatAvailable,
  ski: dto.ski,
  availableSmgwSkis: dto.availableSmgwSkis,
  trustedSmgwSkis: dto.trustedSmgwSkis,
})

export default fromSmartMeterGatewayDtoToModelTransformer
